import Badge from "../../shared/Badge";
import { getDriverComplianceBadge } from "../../utils/driver-profile.utils";

/**
 * Compact compliance badge for driver list rows and selects.
 *
 * @param {{driver?:Object, className?:string}} props
 */
const DriverComplianceBadge = ({ driver, className = "" }) => {
  const badge = getDriverComplianceBadge(driver);

  return (
    <Badge
      className={className}
      label={badge.label}
      color={badge.color}
      size="sm"
    />
  );
};

export default DriverComplianceBadge;
